import React from 'react';
import Select from 'react-select';
import { FormControl } from '@tricor-digital-team/vistra-design-system';

const CustomSelect = ({
  labelText,
  isRequired,
  isInvalid,
  errorText,
  value,
  options,
  id,
  placeholder,
  key,
  name,
  onChange,
}) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption?.value);
  };
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: '8px',
      padding: '6px',
      borderColor: isInvalid ? 'red' : '#4B5563',
      boxShadow: 'none',
      '&:hover': {
        borderColor: isInvalid ? 'red' : '#aaa',
      },
      '&:focus-within': {
        borderColor: '#60A5FA',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#6B7280',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      zIndex: 100,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: '#4B5563',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
      color: 'black',
      padding: '10px',
    }),
  };

  return (
    <form
      autocomplete="off"
      onKeyDown={(e) => {
        if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
          e.preventDefault();
        }
      }}
    >
      <FormControl
        isRequired={isRequired}
        errorText={errorText}
        isInvalid={isInvalid}
        labelText={labelText}
        className="w-full"
      >
        <Select
          isSearchable
          menuPlacement="auto"
          key={key}
          id={id}
          name={name}
          className="vistra-custom-select"
          options={options}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          styles={customStyles}
        />
      </FormControl>
    </form>
  );
};

export default CustomSelect;
